import "../Ohio/style.scss";
import "./style.scss";
import React, {Suspense} from "react";
import {Link} from "react-router-dom";
import 'react-bootstrap-typeahead/css/Typeahead.css';
import Header from "../header/Heade";
import Navbar from "../Navbar/Navbar";
import Footer from "../footer/Footer";
import Seo from "../Seo";
import Loader from "../loader/Loader";
import {GOOGLE_RATING, GOOGLE_REVIEWS, GOOGLE_URL} from "../../googleListing";

const LazyQuote = React.lazy(() => import("../quote/Quote"));

// Landing pages for vehicles other than cars (Google Ads campaign 2, 2026-11).
// Facts are owner-stated (memory leader-payment-terms): Leader books RVs (travel trailers, fifth wheels,
// bumper pulls, motorhomes, inoperable), boats with or without a trailer, golf carts and jet skis.
// RV and boat prices vary too much to publish; a golf cart prices close to an SUV on the same route.
// Deposit timing varies by deal, so no page states one timing.
const PHONE = "(567) 666-4696";

const PAY = {q: "When do I pay?",
    a: "The deposit is charged by card, and your agent tells you when. The balance is paid to the driver after delivery."};
const PRICE_HOLDS = {q: "Can the price change after I book?",
    a: "Your price is written into your contract and into the carrier's contract. Nobody, the driver included, can ask for more for the job as described."};
const INSURED = {q: "Is it insured on the truck?",
    a: "The carrier's cargo cover is included in the price. Once a carrier is assigned, you get its insurance certificate, MC and DOT numbers, and the driver's name and phone."};

export const PAGES = {
    rv: {
        path: "/rv-transport",
        vehicleType: "RV/Trailer",
        photo: {name: "rv-owner-alliance", alt: "Alliance fifth wheel hitched to a hauler truck, a Leader Auto Ship job", w: 640, h: 479},
        title: "RV Transport: Travel Trailers, Fifth Wheels & Motorhomes | Leader Auto Ship",
        description: `Leader Auto Ship books RV transport state to state for travel trailers, fifth wheels, bumper pulls and motorhomes, running or not. Rated ${GOOGLE_RATING} from ${GOOGLE_REVIEWS} Google reviews.`,
        h1: "RV transport for travel trailers, fifth wheels and motorhomes",
        lede: "Leader Auto Ship books licensed carriers to move RVs from state to state. Towables and motorhomes, running or not.",
        types: ["Travel trailers", "Fifth wheels", "Bumper pulls", "Motorhomes", "RVs that don't run"],
        priceTitle: "What RV transport costs",
        price: "RV prices vary too much to publish one range. The type, the size, whether it runs and the route set the price. Send the details in the form and we quote your route.",
        ready: ["Year, make and model", "Length", "Towable or motorized", "Running or not", "Pickup and delivery ZIP codes", "Your dates"],
        faq: [
            {q: "Can you move an RV that doesn't run?",
                a: "Yes. We book transport for RVs that don't run. Say so in the quote so the carrier comes ready for it."},
            {q: "How much does RV transport cost?",
                a: "It depends on the type, the size, whether it runs and the route. We don't publish a range because it varies too much. Send the details and we quote your route."},
            PAY, PRICE_HOLDS, INSURED,
        ],
        cta: "Ship your RV",
    },
    boat: {
        path: "/boat-transport",
        vehicleType: "Boat",
        photo: {name: "boat-owner-mystic", alt: "Teal performance boat with four outboard engines on a triple-axle trailer, a Leader Auto Ship job", w: 1200, h: 900},
        title: "Boat Transport With or Without a Trailer | Leader Auto Ship",
        description: `Leader Auto Ship books boat transport state to state, on your trailer or without one, plus jet skis. Rated ${GOOGLE_RATING} from ${GOOGLE_REVIEWS} Google reviews.`,
        h1: "Boat transport, with or without your trailer",
        lede: "Leader Auto Ship books licensed carriers to move boats from state to state, on their own trailer or without one. Jet skis too.",
        types: ["Boats on their own trailer", "Boats without a trailer", "Jet skis"],
        priceTitle: "What boat transport costs",
        price: "Boat prices vary too much to publish one range. The length, whether it rides on its own trailer and the route set the price. Send the details in the form and we quote your route.",
        ready: ["Year, make and model", "Length", "On a trailer or not", "Pickup and delivery ZIP codes", "Your dates"],
        faq: [
            {q: "Do I need my own trailer?",
                a: "No. We book transport for boats on their own trailer and for boats without one. Tell us which in the quote."},
            {q: "Do you ship jet skis?",
                a: "Yes. In the form, pick PWC as the vehicle type."},
            {q: "How much does boat transport cost?",
                a: "It depends on the length, whether the boat has its own trailer and the route. We don't publish a range because it varies too much. Send the details and we quote your route."},
            PAY, PRICE_HOLDS, INSURED,
        ],
        cta: "Ship your boat",
    },
    golf: {
        path: "/golf-cart-shipping",
        vehicleType: "Other",
        photo: {name: "golf-cart-palms", alt: "Golf cart parked on a path under palm trees", w: 1200, h: 801},
        title: "Golf Cart Shipping State to State | Leader Auto Ship",
        description: `Leader Auto Ship books golf cart shipping state to state. A golf cart costs about what an SUV does on the same route. Rated ${GOOGLE_RATING} from ${GOOGLE_REVIEWS} Google reviews.`,
        h1: "Golf cart shipping, state to state",
        lede: "Leader Auto Ship books licensed carriers to move golf carts between states. Taking one south for the winter, or bringing it home in spring?",
        types: ["Golf carts", "Jet skis (see our boat page)"],
        priceTitle: "What golf cart shipping costs",
        price: "A golf cart costs about what an SUV does on the same route. Send the route in the form for your price. Pick Other as the vehicle type and put the golf cart's make and model in.",
        ready: ["Make and model", "Pickup and delivery ZIP codes", "Your dates"],
        faq: [
            {q: "How much does it cost to ship a golf cart?",
                a: "About what an SUV costs on the same route. Send the pickup and delivery ZIP codes for your price."},
            {q: "Which vehicle type do I pick in the form?",
                a: "Pick Other and put the golf cart's make and model in the next fields."},
            PAY, PRICE_HOLDS, INSURED,
        ],
        cta: "Ship your golf cart",
    },
};

const scrollTop = () => window.scrollTo(0, 0);

const Specialty = ({page}) => {
    const p = PAGES[page];
    const jsonLd = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: p.faq.map(({q, a}) => ({"@type": "Question", name: q, acceptedAnswer: {"@type": "Answer", text: a}})),
    };
    return <div className="ohio-container specialty-container">
        <Seo title={p.title} description={p.description} path={p.path} jsonLd={jsonLd}/>

        <header>
            <Header/>
            <Navbar/>
        </header>

        <main>
            <section className="ohio-hero specialty-hero">
                <div className="hero-grid">
                <div className="inner">
                    <strong className="eyebrow">Licensed broker · MC #1638331 · USDOT #4232283</strong>
                    <h1>{p.h1}</h1>
                    <p className="lede">{p.lede}</p>
                    <a className="rating" href={GOOGLE_URL} target="_blank" rel="noopener noreferrer">
                        <span className="stars" aria-hidden="true">★★★★★</span>
                        <span><b>{GOOGLE_RATING}</b> from {GOOGLE_REVIEWS} Google reviews</span>
                        <span className="as-of">October 2026</span>
                    </a>
                    <div className="actions">
                        <a href="#quote" className="btn primary">Get a free quote</a>
                        <a href="tel:+15676664696" className="btn">Call {PHONE}</a>
                    </div>
                </div>
                {/* Pexels photos (free license) or the owner's job photos, logged in E:\media-library\used-assets.json */}
                <img className="hero-photo" src={`/images/specialty/${p.photo.name}.webp`}
                     srcSet={p.photo.w > 720 ? `/images/specialty/${p.photo.name}-720.webp 720w, /images/specialty/${p.photo.name}.webp ${p.photo.w}w` : undefined}
                     sizes="(max-width: 768px) 100vw, 520px" width={p.photo.w} height={p.photo.h} alt={p.photo.alt}/>
                </div>
            </section>

            <section className="ohio-section specialty-quote" id="quote">
                <h2>Get your quote</h2>
                <div className="specialty-grid">
                    <div className="quote-card">
                        <Suspense fallback={<Loader/>}>
                            <LazyQuote vehicleType={p.vehicleType}/>
                        </Suspense>
                    </div>
                    <div className="specialty-side">
                        <h3>We book</h3>
                        <ul className="types">{p.types.map(t => <li key={t}>{t}</li>)}</ul>
                        <h3>Have this ready</h3>
                        <ul className="types">{p.ready.map(t => <li key={t}>{t}</li>)}</ul>
                    </div>
                </div>
            </section>

            <section className="ohio-section">
                <h2>{p.priceTitle}</h2>
                <p className="intro">{p.price}</p>
            </section>

            <section className="ohio-section">
                <h2>How it works</h2>
                <ol className="steps">
                    <li><b>Quote.</b> Tell us the pickup and delivery ZIP codes, the vehicle and your dates.</li>
                    <li><b>Carrier assigned.</b> We book a licensed carrier and send you the driver's name and phone,
                        the insurance certificate, MC and DOT numbers.</li>
                    <li><b>Pickup.</b> Door to door where the truck can reach. Most carriers run 40-foot-plus trailers,
                        so a large parking lot nearby often works best.</li>
                    <li><b>Delivery.</b> You check it over and pay the balance to the driver.</li>
                </ol>
            </section>

            <section className="ohio-section">
                <h2>Questions</h2>
                <div className="faq">
                    {p.faq.map(({q, a}) => <details key={q}>
                        <summary>{q}</summary>
                        <p>{a}</p>
                    </details>)}
                </div>
                <p className="note">
                    Shipping a car too? <Link to="/get-quote" onClick={scrollTop}>Get a car quote</Link>. Read
                    what customers say on our <Link to="/reviews" onClick={scrollTop}>reviews page</Link>.
                </p>
            </section>

            <section className="ohio-cta">
                <h2>{p.cta}</h2>
                <div className="actions">
                    <a href="#quote" className="btn primary">Get a free quote</a>
                    <a href="tel:+15676664696" className="btn">Call {PHONE}</a>
                </div>
                {/* Required by 49 CFR 371.7(b): advertising must show broker status. Keep this line. */}
                <p className="disclosure">
                    Leader Auto Ship LLC is a licensed transportation broker (MC #1638331, USDOT #4232283) and arranges
                    transport with licensed, insured carriers.
                </p>
            </section>
        </main>

        <footer>
            <Footer/>
        </footer>
    </div>;
};

export default Specialty;
